import React, { useState } from "react";
import { Bell, BellOff, UserPlus, UserCheck } from "lucide-react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

export default function FollowButton({ profile, onChange }) {
  const { t, user } = useApp();
  const [busy, setBusy] = useState(false);
  if (!profile || (user && user.user_id === profile.user_id)) return null;
  const call = async (fn) => {
    if (!user) { toast.info(t("signInPitch")); return; }
    setBusy(true);
    try { const { data } = await fn(); onChange({ ...profile, me_following: data.following, me_notify: !!data.notify, followers: data.followers }); }
    catch (err) { toast.error(err.response?.data?.detail || "Failed"); }
    setBusy(false);
  };
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="follow-controls">
      {profile.me_following ? (
        <button disabled={busy} onClick={() => call(() => api.delete(`/users/${profile.user_id}/follow`))} className="gg-btn !py-2 !px-3 text-xs !bg-foreground !text-background" data-testid="btn-unfollow"><UserCheck className="w-4 h-4" />{t("following")}</button>
      ) : (
        <button disabled={busy} onClick={() => call(() => api.post(`/users/${profile.user_id}/follow`, { notify: true }))} className="gg-btn-primary !py-2 !px-3 text-xs" data-testid="btn-follow"><UserPlus className="w-4 h-4" />{t("follow")}</button>
      )}
      {profile.me_following && (
        <button disabled={busy} onClick={() => call(() => api.post(`/users/${profile.user_id}/follow`, { notify: !profile.me_notify }))} className="gg-btn !py-2 !px-3 text-xs" title={t("notifyNewEvents")} data-testid="btn-notify-toggle" aria-pressed={profile.me_notify}>
          {profile.me_notify ? <Bell className="w-4 h-4" /> : <BellOff className="w-4 h-4" />}<span className="hidden sm:inline">{profile.me_notify ? t("emailOn") : t("emailOff")}</span>
        </button>
      )}
    </div>
  );
}
